/** Strip provider rich-text markup like <target compositionId="...">Label</target> → Label */
export function formatDescriptAgentResponseForDisplay(raw: string): string {
  if (!raw) return '';
  let s = raw.replace(/<target\b[^>]*>([\s\S]*?)<\/target>/gi, (_, inner: string) => inner.trim());
  s = s.replace(/<[^>]+>/g, '');
  s = s.replace(/\*\*([^*]+)\*\*/g, '$1');
  return s.trim();
}
